import { IconName } from '@aibees/shared/components';

export interface PeopleSidebarUpdatesProps {
  className?: string;
}

export enum PeopleUpdatesTabs {
  Insight = 'Insight',
  Contact = 'Contact',
  Analysis = 'Analysis',
}

export interface PeopleUpdatesTabInfo {
  title: PeopleUpdatesTabs;
  icon: IconName;
  content: React.ReactElement;
  count?: number;
}
